import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { DealerCadastroComponent } from './dealer-cadastro/dealer-cadastro.component';
import { DealerFiltroComponent } from './dealer-filtro/dealer-filtro.component';
import { DealerListaComponent } from './dealer-lista/dealer-lista.component';
import { DealerService } from './dealer-service/dealer.service';
import { DealerComponent } from './dealer.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    DealerComponent
  ],
  declarations: [
    DealerComponent,
    DealerListaComponent,
    DealerCadastroComponent,
    DealerFiltroComponent
  ],
  providers: [
    DealerService
  ]
})
export class DealerModule { }
